import React, { useContext, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Journey } from '../../../consts/Common';
import { SiteContext } from '../../../context/SiteContext';
import { useJourney } from '../../sitePages/Layout';
import { ProductType } from '../CommonTypes';
import { getSelectedProducts } from '../ProductMethods';
import SummaryPersonalDetails from '../Summary/SummaryPersonalDetails';
import SummaryQuote from '../Summary/SummaryQuote';
import SummaryVehicle from '../Summary/SummaryVehicle';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { t } from 'i18next';

type ConfirmationExtraDetailsProps = {
  referenceText: string;
};

const ConfirmationExtraDetails = ({
  referenceText
}: ConfirmationExtraDetailsProps): JSX.Element => {
  const { journey } = useJourney();
  const {
    products,
    personalDetail,
    orderNumbers,
    policyStartDate,
    bankAuthorisationCode,
    vehicle
  } = journey;
  const { site } = useContext(SiteContext);
  const cms = site.content;
  const [expanded, setExpanded] = useState<string | false>('planPanel');
  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  let selectedQuotes: ProductType[] = [];
  if (products && products !== undefined)
    selectedQuotes = getSelectedProducts(products);

  return (
    <>
      <Accordion
        expanded={expanded === 'planPanel'}
        onChange={handleChange('planPanel')}
        className='accordion-margintop'>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='planPaneld-content'
          id='planPaneld-header'>
          <p className={'p1'}>{t('confirmation.product-details-heading')}</p>
        </AccordionSummary>
        <AccordionDetails>
          <div>
            {selectedQuotes.map((quote: ProductType, index) => (
              <SummaryQuote
                key={index}
                quote={quote}
                policyStartDate={policyStartDate}
                error={''}
                isPaymentDone={true}
                orderNumbers={orderNumbers}
                bankAuthorisationCode={bankAuthorisationCode}
                referenceText={referenceText}
                culture={site.cultureCode}
              />
            ))}
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === 'vehiclePanel'}
        onChange={handleChange('vehiclePanel')}
        className='accordion-margintop'>
        <AccordionSummary
          expandIcon={
            <ExpandMoreIcon
              className={expanded === 'vehiclePanel' ? 'primary-color' : ''}
            />
          }
          aria-controls='vehiclePaneld-content'
          id='vehiclePaneld-header'>
          <p
            className={expanded === 'vehiclePanel' ? 'p1 primary-color' : 'p1'}>
            {t('confirmation.vehicle-details-heading')}
          </p>
        </AccordionSummary>
        <AccordionDetails>
          <SummaryVehicle
            vehicle={vehicle}
            journeyType={Journey.Renewals}
            culture={site.cultureCode}
          />
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === 'customerPanel'}
        onChange={handleChange('customerPanel')}
        className='accordion-margintop'>
        <AccordionSummary
          expandIcon={
            <ExpandMoreIcon
              className={expanded === 'customerPanel' ? 'primary-color' : ''}
            />
          }
          aria-controls='customerPaneld-content'
          id='customerPaneld-header'>
          <p
            className={
              expanded === 'customerPanel' ? 'p1 primary-color' : 'p1'
            }>
            {t('confirmation.customer-details-heading')}
          </p>
        </AccordionSummary>
        <AccordionDetails>
          <SummaryPersonalDetails
            personalDetail={personalDetail}
            isConfirmationScreen={true}
            culture={site.cultureCode}
            countryCode={site.countryCode}
            phoneNumberLabel={cms.customerPage.phoneNumberLabel}
          />
        </AccordionDetails>
      </Accordion>
    </>
  );
};

export default ConfirmationExtraDetails;
